import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { PassDocument, passesPullQueryBuilder } from './queryBuilder';

export function passesFamilyMember(
  configBuilder: ConfigBuilder,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<PassDocument> {
  const syncConfig = configBuilder<PassDocument>(RxdbCollectionNameV2.PASSES);
  doNotAutoSync(syncConfig);

  pull(syncConfig, passesPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.PASSES, replicationState, [sites]);
}
